<template>
  <div class="errors-container">
    <!--        <slide-y-down-transition>-->
    <!--            <md-icon class="error" v-show="errorsList.length">close</md-icon>-->
    <!--        </slide-y-down-transition>-->
    <!--        <slide-y-down-transition>-->
    <!--            <md-icon class="success" v-show="!errorsList.length">done</md-icon>-->
    <!--        </slide-y-down-transition>-->
    <div class="errors-list">
      <div v-for="error in errorsList">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
export default {
  name: "ErrorsWings",
  components:{SlideYDownTransition},
  props:{
    errorsList:{}
  },
}
</script>
